<script lang="ts" setup>
import VMenuButton from '@shared/component/VMenuButton/VMenuButton.vue';
</script>
<template>
  <VMenuButton
    :button-props="{}"
    menu-position="under"
    :menu-props="{
      model: [
        {
          label: 'Zakelijk',
          url: '/app/crm/relatiegegevens/nieuw?soort=Z',
          icon: 'far fa-building',
        },
        {
          label: 'Particulier',
          url: '/app/crm/relatiegegevens/nieuw?soort=P',
          icon: 'far fa-user',
        },
      ],
    }"
  >
    Nieuwe relatie
  </VMenuButton>
</template>
